import React, { Component } from "react";
import { connect } from "react-redux";
import { onPractitionerSelect } from "./stepHelpers";
import { TextButton, StepItem } from "../Shared";
import { practitionerSelector } from "../../selectors";
import {
  updateAppointmentDetail,
  toggleControl,
  goToStep,
  goBackToStep,
  completeStep
} from "../../actions";
import * as STEP_KEYS from "../../consts";

class PractitionerSelect extends Component {
  handleSelect = props => {
    onPractitionerSelect(props, props.value);
  };

  componentDidMount = () => {
    if (
      (this.props.autoSelectAny || this.props.value !== "") &&
      this.props.current
    ) {
      this.handleSelect(this.props);
    }
  };

  componentWillReceiveProps = nextProps => {
    if (!nextProps.required && this.props.current) {
      this.handleSelect(nextProps);
    }
  };

  shouldComponentUpdate = (nextProps, nextState) => {
    if (
      this.props.value === nextProps.value &&
      this.props.current === nextProps.current
    ) {
      return false;
    }
    return true;
  };

  render() {
    return !this.props.autoSelectAny ? (
      <StepItem>
        {this.props.hintText}
        <TextButton
          placeholder="[select practitioner]"
          value={this.props.text}
          onClick={() => this.props.toggleControl(STEP_KEYS.PRACTITIONER, true)}
          reload={this.props.reload}
        />
      </StepItem>
    ) : null;
  }
}

export default connect(practitionerSelector, {
  updateAppointmentDetail,
  toggleControl,
  goToStep,
  goBackToStep,
  completeStep
})(PractitionerSelect);



// WEBPACK FOOTER //
// ./src/modules/BookingPortal/components/Steps/PractitionerSelect.js